export const NAV_BAR_HEIGHT_PX = 55;
export const BOTTOM_NAV_BAR_HEIGHT_PX = 70;